import React from 'react'

import { useModal } from '_hooks'

import { useEventFeedsContext } from '../../context/index.jsx'
import Collapsible from '../collapsible/index.jsx'

import FiltersTable from './filters-table/index.jsx'
import FiltersModal from './modal-add-filters/index.jsx'
import AddFilter from './add-filter/index.jsx'

import { updateEventFeed } from '_services/data-explorer'
import { logErrorAsync } from '../../../../lib/utility.js'

const FilterConfiguration = ({}, ref) => {
  const {
    id,
    querySectionsCollapsed: { filter: filterCollapsed },
    ACTIONS,
    dispatch,
    data,
  } = useEventFeedsContext()
  const modal = useModal()

  const setFilterCollapsed = (value) => {
    dispatch({ type: ACTIONS.UPDATE_QUERY_SECTION_COLLAPSED, payload: { filter: !value } })
  }

  const handleDeleteAll = async () => {
    try {
      const newData = { ...data, filters: [] }
      const response = id !== 'discovery' ? await updateEventFeed(id, newData) : newData
      dispatch({ type: ACTIONS.SET_DATA, payload: response })
      toast('Changes saved')
    } catch (error) {
      logErrorAsync(error)
      toast.error(error.message)
    }
  }

  return (
    <Collapsible
      ref={ref}
      title="Filters"
      onOpenClick={modal.handleOpenModal}
      showOpenButton={data.deliveries?.[0]?.status !== 'snapshot'}
      onDeleteAllClick={handleDeleteAll}
      showDeleteAllButton={data.deliveries?.[0]?.status !== 'snapshot' && data.filters?.length > 0}
      managedState={[!filterCollapsed, setFilterCollapsed]}
    >
      <FiltersModal id={id} isOpen={modal.isOpen} onClose={modal.handleCloseModal} />
      <FiltersTable />
      <AddFilter />
    </Collapsible>
  )
}

export default React.forwardRef(FilterConfiguration)
